import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, Sparkles } from 'lucide-react';
const allTreatments = [{
  name: 'Lipo Chin',
  gender: 'Para Mujeres',
  shortDesc: 'Defined jawline without surgery',
  image: 'https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=400&h=300&fit=crop'
}, {
  name: 'Lipo 360',
  gender: 'Para Mujeres',
  shortDesc: 'Complete midsection sculpting',
  image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop'
}, {
  name: 'Lipo 360 + BBL',
  gender: 'Para Mujeres',
  shortDesc: 'Sculpt & enhance naturally',
  image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=400&h=300&fit=crop'
}, {
  name: 'Lipo Chin for Men',
  gender: 'Para Hombres',
  shortDesc: 'Masculine jawline definition',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=300&fit=crop'
}, {
  name: 'Skinny Arms',
  gender: 'Para Mujeres',
  shortDesc: 'Elegant, toned arms',
  image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=300&fit=crop'
}, {
  name: 'Chest Lipo',
  gender: 'Para Hombres',
  shortDesc: 'Athletic chest definition',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=300&fit=crop'
}, {
  name: 'Breast Enhancement',
  gender: 'Para Mujeres',
  shortDesc: 'Natural volume boost',
  image: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=400&h=300&fit=crop'
}, {
  name: 'Love Handles Lipo',
  gender: 'Para Hombres',
  shortDesc: 'V-shaped physique',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop'
}];
const whyChooseUs = ['Minimally invasive', 'Fast recovery', 'Financing available', 'Multiple U.S. locations', '10,000+ procedures', 'Board-certified'];
interface ServicesGridProps {
  onCtaClick: () => void;
}
export function ServicesGrid({
  onCtaClick
}: ServicesGridProps) {
  return <section className="w-full py-20 lg:py-24 bg-gradient-to-b from-white via-brand-aqua/10 to-white relative overflow-hidden" data-id="element-384">
      {/* Decorative background */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-385">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/5 rounded-full blur-3xl" data-id="element-386" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-brand-primary/10 rounded-full blur-3xl" data-id="element-387" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-388">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-389">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-gold/10 rounded-full mb-4" data-id="element-390">
            <Sparkles className="w-4 h-4 text-brand-gold" data-id="element-391" />
            <span className="text-brand-gold font-semibold text-sm uppercase tracking-wider" data-id="element-392">
              Our Treatments
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-brand-navy mb-6" data-id="element-393">
            Premium{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-brand-gold" data-id="element-394">
              Body Contouring
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-395">
            Advanced minimally invasive procedures for safe, natural-looking
            results
          </p>
        </motion.div>

        {/* Treatments grid - Premium cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-396">
          {allTreatments.map((treatment, index) => <motion.div key={treatment.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="group bg-white rounded-3xl overflow-hidden shadow-xl border-2 border-transparent transition-all duration-300 hover:border-brand-gold/30 hover:shadow-2xl hover:-translate-y-2 cursor-pointer" onClick={onCtaClick} data-id="element-397">
              {/* Image with premium overlay */}
              <div className="relative h-56 overflow-hidden" data-id="element-398">
                <img src={treatment.image} alt={treatment.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-399" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/90 via-brand-navy/40 to-transparent" data-id="element-400" />

                {/* Gender badge with gold accent */}
                <div className="absolute top-4 right-4" data-id="element-401">
                  <span className={`px-3 py-1.5 rounded-full text-xs font-bold backdrop-blur-md ${treatment.gender === 'Para Mujeres' ? 'bg-pink-500/90 text-white' : 'bg-blue-500/90 text-white'}`} data-id="element-402">
                    {treatment.gender}
                  </span>
                </div>

                {/* Gold accent corner */}
                <div className="absolute top-0 left-0 w-16 h-16 bg-gradient-to-br from-brand-gold/30 to-transparent" data-id="element-403" />
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-404">
                <h4 className="text-lg font-bold text-brand-navy mb-2 group-hover:text-brand-primary transition-colors duration-300" data-id="element-405">
                  {treatment.name}
                </h4>
                <p className="text-gray-600 text-sm mb-4" data-id="element-406">
                  {treatment.shortDesc}
                </p>
                <button className="text-brand-primary font-semibold text-sm flex items-center gap-1 group-hover:gap-2 transition-all duration-300" data-id="element-407">
                  Learn more
                  <span className="text-brand-gold" data-id="element-408">→</span>
                </button>
              </div>
            </motion.div>)}
        </div>

        {/* Why Choose Dermaclinic - Premium box */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-brand-navy via-brand-deep to-brand-navy rounded-3xl p-10 shadow-2xl border border-brand-gold/20" data-id="element-409">
          <div className="flex items-center gap-3 mb-8" data-id="element-410">
            <div className="w-12 h-12 bg-brand-gold/20 rounded-2xl flex items-center justify-center" data-id="element-411">
              <Sparkles className="w-6 h-6 text-brand-gold" data-id="element-412" />
            </div>
            <h3 className="text-3xl font-bold text-white" data-id="element-413">
              Why Clients Choose{' '}
              <span className="text-brand-gold" data-id="element-414">Dermaclinic</span>
            </h3>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-415">
            {whyChooseUs.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-2xl p-4" data-id="element-416">
                <CheckIcon className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-417" />
                <span className="text-white font-medium text-sm" data-id="element-418">{reason}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}